import { createFileRoute } from '@tanstack/react-router'

import { BackofficeLourmelSftpUploadPage } from '#/modules/lourmel/back-office/lourmel-sftp-upload-page/backoffice-lourmel-sftp-upload-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/lourmel-sftp')({
  beforeLoad: ({ context }) => requirePermissions(context, ['report.process']),
  component: function Component() {
    return <BackofficeLourmelSftpUploadPage />
  },
})
